import React from "react";

import favicon from "/static/images/favicon.png";

// This needs to be hardcoded to properly display the image. Otherwise the image URL gets a cache-aware suffix that causes 404s.
const promoImageUrl = "/images/indeed-design-promo.png";

interface SEOProps {
  canonicalUrl?: string;
  customFields?: string;
  description?: string;
  image?: { sourceUrl: string };
  ogDescription?: string;
  ogTitle?: string;
  ogType?: string;
  title: string;
}

export const SEO: React.FC<SEOProps> = ({
  canonicalUrl,
  customFields,
  description = "Learn about Indeed’s brand identity and get inspired by stories from the greater design community.",
  image,
  ogDescription,
  ogTitle,
  ogType = "website",
  title = "Indeed Design",
}) => {
  return (
    <>
      <title>
        {title !== "Indeed Design" ? `${title} | Indeed Design` : title}
      </title>
      <link rel="shortcut icon" type="image/x-icon" href={favicon} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />

      <meta property="og:type" content={ogType} />

      <meta property="og:image" content={image?.sourceUrl ?? promoImageUrl} />
      <meta property="og:url" content={canonicalUrl} />
      <script type="application/ld+json">{customFields}</script>
      <noscript>
        You’ll need to turn on JavaScript in your browser settings to use this
        site.
      </noscript>
    </>
  );
};
